<template>
  <div>
    <div class="title">
      <span class="name">{{ searchForm.yearMonth }}月经营数据</span>
    </div>
    <div class="total-content">
      <div class="left">
        <div class="item">
          <img class="icon" src="@/assets/img/operate/yg.png" />
          <div class="content">
            <span class="label">营收计划（元）</span>
            <div class="value">
              <span>¥</span>
              <span>{{ details.planRevenueAmount }}</span>
            </div>
          </div>
        </div>
        <div class="item">
          <img class="icon" src="@/assets/img/operate/yg.png" />
          <div class="content">
            <span class="label">实际成本（元）</span>
            <div class="value">
              <span>¥</span>
              <span>{{ details.actualCostAmount ?? '--' }}</span>
            </div>
            <div class="desc">
              <span>较计划</span>
              <span>{{ Math.abs(details.actualToPlanCostAmount) }}</span>
              <img v-if="details.actualToPlanCostAmount > 0" src="@/assets/img/operate/up.png" />
              <img v-if="details.actualToPlanCostAmount < 0" src="@/assets/img/operate/down.png" />
            </div>
          </div>
        </div>
        <div class="item">
          <img class="icon" src="@/assets/img/operate/yg.png" />
          <div class="content">
            <span class="label">实际利润（元）</span>
            <div class="value">
              <span>¥</span>
              <span>{{ details.actualProfitAmount ?? '--' }}</span>
            </div>
            <div class="desc">
              <span>较计划</span>
              <span>{{ Math.abs(details.actualToPlanProfitAmount) }}</span>
              <img v-if="details.actualToPlanProfitAmount > 0" src="@/assets/img/operate/up.png" />
              <img v-if="details.actualToPlanProfitAmount < 0" src="@/assets/img/operate/down.png" />
            </div>
          </div>
        </div>
        <div class="item">
          <img class="icon" src="@/assets/img/operate/yg.png" />
          <div class="content">
            <span class="label">实际利润率</span>
            <div class="value">
              <span>{{ details.actualProfitPer ?? '--' }}%</span>
            </div>
            <div class="desc">
              <span>较计划</span>
              <span>{{ Math.abs(details.actualToPlanProfitPer) }}%</span>
              <img v-if="details.actualToPlanProfitPer > 0" src="@/assets/img/operate/up.png" />
              <img v-if="details.actualToPlanProfitPer < 0" src="@/assets/img/operate/down.png" />
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="chart-item">
          <div class="chart-title">
            <span class="name">实际成本分类占比</span>
          </div>
          <div class="chart-content" id="chart1"></div>
        </div>
        <div class="chart-item">
          <div class="chart-title">
            <span class="name">计划与实际成本偏差对比</span>
          </div>
          <div class="chart-content" id="chart2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chartMixin from '@/mixins/mixin'
export default {
  name: 'Section2',
  mixins: [chartMixin],
  data() {
    return {
      searchForm: {
        yearMonth: ''
      },
      details: {
        planRevenueAmount: '', // 营收计划金额
        actualCostAmount: '', // 实际成本金额
        planCostAmount: '', // 计划成本金额
        actualToPlanCostAmount: '', // 实际较计划成本差值金额
        actualProfitAmount: '', // 实际利润金额
        planProfitAmount: '', // 计划利润金额
        actualToPlanProfitAmount: '', // 实际较计划利润差值金额
        actualProfitPer: '', // 实际利润率
        planProfitPer: '', // 计划利润率
        actualToPlanProfitPer: '', // 实际较计划利润率差值
        actualCostTypePerList: [], //	实际成本分类占比数组(顺序：人、机、材、间)
        actualCostTypeAmountList: [], // 实际成本分类金额数组(顺序：人、机、材、间)
        planCostTypeAmountList: [], // 计划成本分类金额数组(顺序：人、机、材、间)
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    // do something
    this.$event.$on('projectSearchChange', this.loadData)
  },
  beforeDestroy() {
    this.$event.$off('projectSearchChange')
  },
  methods: {
    loadData(searchForm) {
      console.log('searchForm', searchForm)
      this.searchForm = searchForm
      this.$axios.get(this.$apis.operate.selectCurrentMonth, searchForm).then(res => {
        this.details = res
        this.$nextTick(() => {
          this.initChart1()
          this.initChart2()
        })
      })
    },
    initChart1() {
      const chart = this.$getChartInstance('#chart1')
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c}%'
        },
        legend: {
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 20,
          right: 80,
          top: 'center',
          orient: 'vertical'
        },
        color: ['#47A2FF', '#1AD1B0', '#FBD44C', '#F3657C'],
        series: [
          {
            type: 'pie',
            radius: ['55%', '80%'],
            left: '-20%',
            avoidLabelOverlap: false,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 5
            },
            // label: {
            //   show: false,
            //   position: 'center'
            // },
            label: {
              show: false,
              position: 'center', // 标签显示在外部
              alignTo: 'edge',
              formatter: '{b}\n{d}%'
            },
            avoidLabelOverlap: true, // 自动防止标签重叠
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: this.details.actualCostTypePerList[0], name: '人力成本' },
              { value: this.details.actualCostTypePerList[1], name: '机械成本' },
              { value: this.details.actualCostTypePerList[2], name: '材料成本' },
              { value: this.details.actualCostTypePerList[3], name: '间接费' }
            ]
          }
        ]
      };
      chart.clear()
      chart.setOption(option)
    },
    initChart2() {
      const chart = this.$getChartInstance('#chart2')
      const option = {
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            let tooltipStr = params[0].name + '<br>';
            for (let i = 0; i < params.length; i++) {
              // 显示系列名称、图例颜色和数据信息
              tooltipStr += params[i].marker + ' ' + params[i].seriesName + ' ' + params[i].value + '元<br>';
            }
            return tooltipStr;
          }
        },
        grid: {
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true
        },
        yAxis: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: ['人力成本', '机械成本', '材料成本', '间接费'],
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            fontSize: 16,
            color: '#7F8FA4'
          }
        },
        series: [
          {
            name: '计划',
            type: 'bar',
            barGap: '5%',
            barWidth: 22,
            itemStyle: {
              borderRadius: [50, 50, 0, 0],
              color: '#0D4789',
            },
            data: this.details.planCostTypeAmountList
          },
          {
            name: '实际',
            type: 'bar',
            barGap: '5%',
            barWidth: 22,
            itemStyle: {
              borderRadius: [50, 50, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#FAD961' }, // 起始颜色
                { offset: 0, color: '#FF8C4A' } // 结束颜色
              ]),
            },
            data: this.details.actualCostTypeAmountList
          }
        ]
      }
      chart.clear()
      chart.setOption(option)
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  height: 60px;
  border-bottom: 1px solid #E8E8E8;
  padding: 0 24px;
  display: flex;
  align-items: center;

  span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    line-height: 24px;
    text-align: left;
    font-style: normal;
  }
}

.total-content {
  padding: 20px 24px;
  display: flex;

  .left {
    flex: 1;
    display: flex;
    flex-direction: column;

    .item {
      display: flex;

      &:nth-child(n + 2) {
        margin-top: 30px;
      }

      .icon {
        width: 24px;
        height: 24px;
        margin-right: 16px;
      }

      .content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .label {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #7F8FA4;
          line-height: 24px;
          text-align: left;
          font-style: normal;
        }

        .value {
          display: flex;
          align-items: flex-end;
          margin-top: 16px;

          span {
            &:first-child {
              font-size: 20px;
              margin-right: 10px;
              line-height: 32px;
            }

            &:last-child {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 24px;
              color: #354052;
              line-height: 32px;
              text-align: left;
              font-style: normal;
            }
          }
        }

        .desc {
          display: flex;
          align-items: center;
          margin-top: 20px;

          span {
            &:nth-child(1) {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: #7F8FA4;
              line-height: 24px;
              text-align: left;
              font-style: normal;
            }

            &:nth-child(2) {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: #354052;
              line-height: 24px;
              text-align: left;
              font-style: normal;
              margin-left: 10px;
            }
          }

          img {
            width: 15px;
            height: 18px;
            margin-left: 10px;
          }
        }
      }
    }
  }

  .right {
    width: 505px;
    display: flex;
    flex-direction: column;

    .chart-item {
      display: flex;
      flex-direction: column;
      flex: 1;

      .chart-title {
        padding-bottom: 10px;
        border-bottom: 1px solid #E8E8E8;

        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #000000;
          line-height: 24px;
          text-align: left;
          font-style: normal;
        }
      }

      .chart-content {
        flex: 1;
      }
    }
  }
}
</style>
